module.exports = __webpack_public_path__ + "public/images/icons/qa.77effbcbac6dfcac9d9b1f5795c298dc.png";